import { render, staticRenderFns } from "./UploadBulkLabourerPage.vue?vue&type=template&id=eab29764&scoped=true&"
import script from "./UploadBulkLabourerPage.vue?vue&type=script&lang=js&"
export * from "./UploadBulkLabourerPage.vue?vue&type=script&lang=js&"
import style0 from "./UploadBulkLabourerPage.vue?vue&type=style&index=0&id=eab29764&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab29764",
  null
  
)

export default component.exports